import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const SurveyActionTypes = {
  FETCH_SURVEY_ACTIVITY_INFO: createSubtypes('surveyActivity|fetchSurveyActivityInfo'),
  UPLOAD_SURVEY_FILE_INIT: 'surveyActivity|uploadSurveyFileInit',
  UPLOAD_SURVEY_FILE_FAIL: 'surveyActivity|uploadSurveyFileFail',
  UPLOAD_SURVEY_FILE_DONE: 'surveyActivity|uploadSurveyFileDone',
  UPLOAD_SURVEY_FILE_CANCEL: 'surveyActivity|uploadSurveyFileCancel',
  UPLOAD_SURVEY_PROGRESS: 'surveyActivity|uploadSurveyProgress',
  SAVE_ADDITIONAL_SURVEY_TASK: createSubtypes('surveyActivity|saveAdditionalSurveyTask'),
  DELETE_SURVEY_FILE: createSubtypes('surveyActivity|deleteSurveyFile'),
  UPLOAD_PHOTO_FAILED: 'surveyActivity|uploadPhotoFail',
};
